"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi"));
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'EditStatementDetailDialog',
  data: function data() {
    return {
      visible: false,
      listLoading: false,
      saveLoading: false,
      orderNo: '',
      statementId: null,
      detailType: '',
      listData: []
    };
  },
  methods: {
    open: function open(row, statementId) {
      this.visible = true;
      this.orderNo = row.orderNo;
      this.statementId = statementId;
      this.detailType = row.detailType;
      this.fetchOrderDetail();
    },
    handleClosed: function handleClosed() {
      this.orderNo = '';
      this.statementId = null;
      this.detailType = '';
      this.listData = [];
    },
    navigateToAftersaleDetail: function navigateToAftersaleDetail(aftersaleId) {
      this.$router.push({
        path: "/order/aftersale/aftersaleDetail/".concat(aftersaleId, "/").concat(this.orderNo, "/2")
      });
    },
    fetchOrderDetail: function fetchOrderDetail() {
      var _this = this;
      this.listLoading = true;
      orderListApi.getOrderDetail(this.orderNo, {
        detailType: this.detailType,
        statementId: this.statementId
      }).then(function (res) {
        var list = res && res.orderItemList ? res.orderItemList : [];
        list.forEach(function (item) {
          _this.$set(item, 'isEditing', false);
          _this.$set(item, 'originalSettlePrice', item.settlePrice || 0);
          _this.$set(item, 'editLossAmount', item.lossAmount || 0);
        });
        _this.listData = list;
      }).catch(function (err) {
        _this.$message.error(err.message || '获取订单详情失败');
        _this.listData = [];
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    formatAmount: function formatAmount(val) {
      return val != null ? Number(val).toFixed(2) : '0.00';
    },
    handleEditItem: function handleEditItem(row) {
      this.$set(row, 'isEditing', true);
      this.$set(row, 'actualCalculatedPrice', row.settlePrice || 0);
      this.$set(row, 'editLossAmount', row.lossAmount || 0);
    },
    handleCancelItem: function handleCancelItem(row) {
      row.isEditing = false;
      row.actualCalculatedPrice = row.originalSettlePrice || 0;
      row.editLossAmount = row.lossAmount || 0;
    },
    handleSaveItem: function handleSaveItem(row) {
      var _this2 = this;
      this.saveLoading = true;
      statementApi.updateStatementOrderItemApi({
        id: row.id,
        actualCalculatedPrice: row.actualCalculatedPrice,
        lossAmount: row.editLossAmount,
        detailType: this.detailType,
        statementId: this.statementId
      }).then(function () {
        _this2.$message.success('修改成功');
        row.originalSettlePrice = row.actualCalculatedPrice;
        row.settlePrice = row.actualCalculatedPrice;
        row.lossAmount = row.editLossAmount;
        row.isEditing = false;
        _this2.$emit('refresh');
      }).catch(function (err) {
        _this2.$message.error(err.message || '修改失败');
      }).finally(function () {
        _this2.saveLoading = false;
      });
    }
  }
};